<template>
  <div class="box">
    <div class="box-top">
      <!-- <img class="box-top-logo" src="../assets/images/yaozhibo_logo@2x.png" alt="" /> -->
      <div class="box-top-container">
        <!-- 添加动画类名的容器 -->
        <div class="box-top-container-left animate-item left-item">
          <img class="box-top-container-left-img" src="../assets/images/link_logo@2x.png" alt="" />
          <div class="box-top-container-left-div">
			<div class="box-top-container-left-div-text">
				<span>Link语音是一个专注于声音社交的互动平台，</span>
				<span>主打“用声音连接彼此”的理念。</span>
				<span>在这里，你可以卸下现实身份的包袱，无需露脸，</span>
				<span>仅凭声音与来自五湖四海的朋友进行真诚、有趣的交流。</span>
			</div>
            <!-- <div class="box-top-container-left-div-left">
			  <a href="https://www.pgyer.com/youshengzhibo-ios"  target="_blank" rel="noopener noreferrer">
			    <img class="box-top-container-left-div-left-img" src="../assets/images/ios@2x.png" alt="iOS下载" />
			  </a>
			  <a href="https://www.pgyer.com/youshengzhibo-ios"  target="_blank" rel="noopener noreferrer"class="download-link">
			    <img class="box-top-container-left-div-left-img" src="../assets/images/android@2x.png" alt="iOS下载" />
			  </a>
            </div> -->
            <!-- <div class="box-top-container-left-div-right">
              <img class="box-top-container-left-div-right-img" src="../assets/images/ewm.png" alt="" />
              <span>扫码下载优声直播APP</span>
            </div> -->
          </div>
        </div>
        <!-- 添加动画类名的图片 -->
        <img class="box-top-container-img animate-item right-item" src="../assets/images/img@2x.png" alt="" />
      </div>
    </div>
	<div class="box-bottom">
		<div class="box-bottom-div">
			<span @click="goAgreement(1)">用户协议</span>
			<span @click="goAgreement(2)">隐私协议</span>
		</div>
		<div class="box-bottom-div">应用 App 名称：Link语音 App 版本：V1.0</div>
		<div class="box-bottom-div">公司名称：文安县宸链网络科技有限公司</div>
		<div class="box-bottom-div">联系电话：17692639089</div>
		<div class="box-bottom-div">地址：河北省廊坊市文安县苏桥镇团结村苏桥鱼馆西50米</div>
		<div class="box-bottom-div">备案信息：冀ICP备2026010770号-1</div>
	</div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  data() {
    return {
		newWindow:null
	};
  },
  mounted() {
    // 动态注入 viewport meta 标签以支持移动端缩放
    if (!document.querySelector('meta[name="viewport"]')) {
      const meta = document.createElement('meta');
      meta.name = 'viewport';
      meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

    // 页面加载完成后触发动画（加延迟确保DOM渲染完成）
    setTimeout(() => {
      const animateItems = document.querySelectorAll('.animate-item');
      animateItems.forEach(item => {
        item.classList.add('animate-active');
      });
    }, 100);
  },
  methods: {
	  // 跳转协议页面，携带参数
	  goAgreement(data){
	  		  sessionStorage.setItem('user', 1);
	  		  // 打开新窗口并加载指定路由
	  		  this.newWindow = window.open('', '_blank');
	  				
	  		  if (this.newWindow) {
	  			// 将路由的完整 URL 写入新窗口
	  			const params = { id: 123 };
	  			const query = { type: data };
	  			const route = this.$router.resolve({ name: 'xieyi',params,query });
	  			this.newWindow.location.href = route.href;
	  		  } else {
	  			alert('弹出窗口被阻止，请允许弹出窗口后重试。');
	  		  }
	  }
  },
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
.box {
	width: 100%;
	overflow-x: hidden;
}
.box-top {
	background-image: url('http://ahhzy-live-app.oss-cn-beijing.aliyuncs.com/webStorage/web_17763946600029654.png'); // 替换成你的背景图片路径
	background-repeat: no-repeat; // 禁止背景图片重复
	background-size: cover; // 覆盖整个容器，保持比例
	background-position: center center; // 背景图片居中显示
	background-attachment: scroll; /* 默认滚动，PC 端再启用固定 */
	min-height: auto;
	padding: 40px 0px;
}
.box-top-logo {
    width: 150px;
    //margin: 20px auto;
    display: block;
}
.box-top-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    overflow: hidden;
}
.box-top-container-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}
.box-top-container-left-img {
    width: 200px;
}
.box-top-container-left-div {
    display: flex;
    align-items: center;
    padding-top: 30px;
    width: 100%;
}
.box-top-container-left-div-left {
    display: flex;
    flex-direction: column;
}
.box-top-container-left-div-left-img {
    width: 220px;
}
.box-top-container-left-div-left-img1 {
    width: 220px;
}
.download-link{
	margin-top: 30px;
}
.box-top-container-left-div-right {
    padding-left: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.box-top-container-left-div-right-img {
    width: 168px;
}
.box-top-container-left-div-right span {
    padding-top: 18px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    line-height: 24px;
}
.box-top-container-img {
    width: 90%;
    margin-left: 0;
    margin-top: 40px;
}
// 动画核心样式
.animate-item {
    transition: transform 0.8s ease-in-out;
    opacity: 0;
}
.left-item {
    transform: translateX(-100%);
}
.right-item {
    transform: translateX(100%);
}
.animate-active {
    transform: translateX(0);
    opacity: 1;
}
.box-bottom{
	padding: 30px 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: #E2E2E2;
}
.box-bottom-div{
	font-family: MiSans, MiSans;
	font-weight: 400;
	font-size: 12px;
	color: #333333;
	line-height: 22px;
	text-align: center;
}
.box-bottom-div span{
	padding: 0px 5px;
	cursor: pointer;
}
.box-top-container-left-div-text{
	display: flex;
	flex-direction: column;
	font-family: MiSans, MiSans;
	font-weight: 500;
	font-size: 16px;
	color: #333333;
	line-height: 30px;
	width: 100%;
	padding: 0 10px;
	text-align: left;
	word-break: break-all;
}
.box-top-container-left-div-text span{
	margin-bottom: 12px;
	display: block;
}

/* PC 端样式 */
@media screen and (min-width: 1024px) {
    .box-top {
        background-attachment: fixed;
        min-height: 100vh;
        padding-bottom: 0;
    }
    .box-top-logo {
        width: 250px;
        margin: 20px 0px 0px 170px;
    }
    .box-top-container {
        flex-direction: row;
        padding: 0;
    }
    .box-top-container-left {
        align-items: flex-start;
        width: auto;
    }
    .box-top-container-left-img {
        width: 320px;
    }
    .box-top-container-left-div {
        padding-top: 80px;
        width: auto;
    }
    .box-top-container-img {
        width: 600px;
        margin-left: 50px;
        margin-top: 0;
    }
    .box-top-container-left-div-text {
        font-size: 20px;
        line-height: 40px;
        width: 550px;
        padding: 0;
        text-align: justify;
    }
    .box-bottom {
        padding: 50px 0px;
    }
    .box-bottom-div {
        font-size: 14px;
        line-height: 30px;
        text-align: left;
    }
}
</style>


// WEBPACK FOOTER //
// Login.vue?2d29164c